import { Group } from '@mantine/core'
import { DirectionArrow } from '../_tiles'
import { useI18n } from '../../_i18n'
import { compassFromDeg, windArrowDeg } from './weatherData'
import { RowUnit } from './Caption'

// An arrow + compass point ("↗ SE") for the seas row. The compass point is a
// word naming a reading, so it takes RowUnit like every other word in a daily
// row — one size, one color, weight doing the separating.
//
// The wind chart below renders its own arrow + compass inline and does NOT
// share this. That is intentional: the chart's typography was tuned by hand
// against the track, so it stays exactly as it was and nothing here reaches
// into it.
//
// Direction is FROM, per the feed's contract: the compass point names where
// the swell is coming from, while the arrow points where it's going
// (deg + 180, via windArrowDeg). That's the app's convention wherever it
// draws a direction — "the arrow shows where it's flowing".
//
// Renders nothing at all for a null direction; the feed uses null for
// "honestly unknown", which must never come out as a north-pointing arrow.
export default function DirectionLabel({ deg, size = 13 }) {
  const { t } = useI18n()
  if (deg == null) return null
  return (
    <Group gap={4} wrap="nowrap" align="center">
      <DirectionArrow deg={windArrowDeg(deg)} size={size} />
      <RowUnit preserveCase>{compassFromDeg(t, deg)}</RowUnit>
    </Group>
  )
}
